import { Spin } from "antd";
import { useState } from "react";
import "../Reporting.scss";
import MessagePopUp from "../../../components/Messages/MessagePopUp";
import SubmittedForApproval from "./SubmittedForApproval";
import SiteVisitReportingList from "./SiteVisitReportingList";
import { useLocation } from "react-router-dom";

function ReportingList() {
  const { search: view } = useLocation();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  return (
    <Spin spinning={loading}>
      <div className="reportingListDiv">
        <div className="d-flex flex-column">
          {view === "?siteVisitReportingList" ? (
            <SiteVisitReportingList
              loading={loading}
              setLoading={setLoading}
              setMessage={setMessage}
            />
          ) : view === "?submittedForApproval" ? (
            <SubmittedForApproval
              loading={loading}
              setLoading={setLoading}
              setMessage={setMessage}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
    </Spin>
  );
}

export default ReportingList;
